import { staticPath } from "faqSrc/lib/$path";
import React, { FC } from "react";
import styled from "styled-components";
import Image from "components/atoms/Image";
import { colorBlack } from "lib/constants";
import {
  convertToExternalUrl,
  convertToSocialUrl,
} from "~/lib/utils/urlHelper";
import { User } from "~/models/user";

interface Props {
  user: User;
}

const CreatorSmallSizeSocialLinks: FC<Props> = ({ user }) => {
  return (
    <SocialLinks>
      {user.blogUrl && (
        <SocialLinkItem
          aria-label="ブログのURL"
          href={convertToExternalUrl({ url: user.blogUrl })}
          rel="noopener nofollow"
          target="_blank"
        >
          <Image
            src={staticPath.img.social.blog_svg}
            alt="ブログのURL"
            width={28}
            height={28}
          />
        </SocialLinkItem>
      )}
      {user.twitterUrl && (
        <SocialLinkItem
          aria-label={`${user.name}のTwitterアカウント`}
          href={convertToSocialUrl({
            socialName: "twitter",
            url: user.twitterUrl,
          })}
          rel="noopener nofollow"
          target="_blank"
        >
          <Image
            src={staticPath.img.social.twitter_svg}
            alt={`${user.name}のTwitterアカウント`}
            width={28}
            height={28}
          />
        </SocialLinkItem>
      )}
      {user.instagramUrl && (
        <SocialLinkItem
          aria-label="InstagramのURL"
          href={convertToSocialUrl({
            socialName: "instagram",
            url: user.instagramUrl,
          })}
          rel="noopener nofollow"
          target="_blank"
        >
          <Image
            src={staticPath.img.social.instagram_svg}
            alt="InstagramのURL"
            width={28}
            height={28}
          />
        </SocialLinkItem>
      )}
      {user.youtubeUrl && (
        <SocialLinkItem
          aria-label="YoutubeのURL"
          href={convertToSocialUrl({
            socialName: "youtube",
            url: user.youtubeUrl,
          })}
          rel="noopener nofollow"
          target="_blank"
        >
          <Image
            src={staticPath.img.social.youtube_svg}
            alt="YoutubeのURL"
            width={28}
            height={28}
          />
        </SocialLinkItem>
      )}
      {user.portfolioUrl1 && (
        <SocialLinkItem
          aria-label="実績として紹介したいページのURL ①"
          href={convertToExternalUrl({ url: user.portfolioUrl1 })}
          rel="noopener nofollow"
          target="_blank"
        >
          <Image
            src={staticPath.img.social.link_svg}
            alt="実績として紹介したいページのURL ①"
            width={28}
            height={28}
          />
        </SocialLinkItem>
      )}
      {user.portfolioUrl2 && (
        <SocialLinkItem
          aria-label="実績として紹介したいページのURL ②"
          href={convertToExternalUrl({ url: user.portfolioUrl2 })}
          rel="noopener nofollow"
          target="_blank"
        >
          <Image
            src={staticPath.img.social.link_svg}
            alt="実績として紹介したいページのURL ②"
            width={28}
            height={28}
          />
        </SocialLinkItem>
      )}
    </SocialLinks>
  );
};

const SocialLinks = styled.div`
  align-items: center;
  color: ${colorBlack[400]};
  display: grid;
  font-size: 15px;
  gap: 4px;
  grid-auto-flow: column;
  grid-template-columns: repeat(auto-fit, 28px);
  justify-content: start;
  line-height: 30px;
`;

const SocialLinkItem = styled.a`
  align-items: center;
  display: grid;
  justify-content: center;
  height: 28px;
  width: 28px;

  &:hover {
    opacity: 0.8;
  }
`;

export default CreatorSmallSizeSocialLinks;
